import { activeMemberships } from "lib/apollo/constants"

const queryMembershipMap = {
  "60ft": "sixtyDayFreeTrialRenewsToMonthlyMembershipId",
  "30ft": "thirtyDayFreeTrialRenewsToMonthlyMembershipId",
  annual: "annualLimitlessMembershipId",
  monthly: "monthlyLimitlessMembershipId",
} as const

export const getMembershipIdFromQuery = (
  locale: string,
  queryMembership: string
): string => {
  if (!queryMembership) return ""
  const membershipKey = queryMembershipMap[queryMembership]
  return activeMemberships[locale][membershipKey]
}
